import { DrawerOpenButton } from "./DrawerOpenButton";
import { NewOrder } from "./NewOrder";
import { NotificationSoundCheck } from "./NotificationSoundCheck";

export const OrderPageRightBar = () => {
  return (
    <>
      <NotificationSoundCheck />
      <DrawerOpenButton />
      <NewOrder />
    </>
  );
};
